const stats = [
  { icon: 'ri-football-line', value: '10万+', label: '年直播赛事' },
  { icon: 'ri-user-star-line', value: '500万+', label: '忠实用户' },
  { icon: 'ri-global-line', value: '50+', label: '覆盖国家' },
  { icon: 'ri-flashlight-line', value: '99.9%', label: '直播稳定性' },
];

const features = [
  {
    icon: 'ri-hd-line',
    title: '高清直播',
    desc: '4K超高清画质，多机位切换，不错过任何一个精彩瞬间',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: '数据解析',
    desc: 'AI智能分析，实时数据更新，助您做出更准确的判断',
  },
  {
    icon: 'ri-secure-payment-line',
    title: '安全可靠',
    desc: '多重加密技术保障，资金安全有保障，放心参与竞猜',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端互通',
    desc: 'Web、iOS、Android全平台覆盖，随时随地畅享体育盛宴',
  },
];

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="text-xs font-bold text-primary-500 uppercase tracking-wider">Why Choose Us</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2 mb-4">
              为什么选择米乐体育
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-8">
              米乐体育深耕体育行业多年，以专业的技术团队和海量赛事资源，
              为全球体育爱好者提供极致的观赛体验和丰富的互动玩法。
            </p>

            <div className="grid grid-cols-2 gap-4">
              {features.map((feat) => (
                <div key={feat.title} className="bg-background-100/70 rounded-xl p-4 hover:bg-accent-50 transition-colors">
                  <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center mb-3">
                    <i className={`${feat.icon} text-accent-500 text-lg`}></i>
                  </div>
                  <h4 className="font-bold text-foreground-900 text-sm mb-1">{feat.title}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20sports%20analysis%20dashboard%20interface%20with%20data%20visualization%20charts%20and%20graphs%2C%20dark%20theme%20with%20warm%20red%20and%20gold%20accent%20highlights%2C%20futuristic%20UI%20design%2C%20professional%20sports%20analytics%20platform%2C%20clean%20minimal%20layout%2C%20glass%20morphism%20effect&width=800&height=1000&seq=stats-img-01&orientation=portrait"
                alt="数据分析"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 right-6 grid grid-cols-4 gap-3">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-xl p-3 text-center border border-background-200/70"
                >
                  <i className={`${stat.icon} text-primary-500 text-base mb-1 block`}></i>
                  <div className="font-heading text-base font-bold text-foreground-900">{stat.value}</div>
                  <div className="text-[10px] text-foreground-400">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}